import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Line, Pie } from 'react-chartjs-2';
import { Select } from 'antd';
import { useEffect, useState } from 'react';

import { InformacionIndicador } from '../../services/perfiles/indicadorPerfilService';

const { Option } = Select;

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const TotalPoblacion = ({ municipio }) => {
    const [rawData, setRawData] = useState([]);
    const [filteredData, setFilteredData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState('2022'); // Default to 2022
    const [selectedAgeRange, setSelectedAgeRange] = useState('all');
    const [lineData, setLineData] = useState(null);
    const [barData, setBarData] = useState(null); // New state for bar chart data
    const [barDataE, setbineData] = useState(null); // New state for bar chart data
    const [pieData, setpieData] = useState(null); // New state for bar chart data
    const [pieDataU, setPieData] = useState(null); // New state for bar chart data

    useEffect(() => {
        if (municipio) {
            fetchData();
        }
    }, [municipio]);

    const fetchData = async () => {
        setLoading(true);
        const vista = 'totalpoblacion';
        setError('');
        try {
            const response = await InformacionIndicador(municipio, vista);
            if (response && response.status === 200) {
                const data = response.data;
                const fetchedData = response.data;
                const uniqueYears = [...new Set(fetchedData.map(item => item.año))];
                setYears(uniqueYears);
                setRawData(fetchedData);
                filterData(fetchedData, selectedYear, selectedAgeRange);
                prepareLineData(data); // Prepare data for line chart
                prepareBarData(data, selectedYear); // Prepare data for bar chart
                preparebarData(data);
                preparepieData(data, years);
                prepareAreaPieData(data, years)
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            setError('Error loading data');
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };
    const parseAgeRange = (range) => {
        if (!range || range === "100+" || range === "+100 años") {
            return 101;
        }
        const [start] = range.split('-').map(Number);
        return start;
    };

    const filterData = (fetchedData, year, ageRange) => {
        const filtered = fetchedData.filter(item => item.año === year && (ageRange === 'all' || item.clasificacion === ageRange));

        const hombreData = filtered.filter(item => item.desagregaciontematica === 'Rangos de edad Hombre');
        const mujerData = filtered.filter(item => item.desagregaciontematica === 'Rangos de edad Mujer');

        const sortedHombres = hombreData.sort((a, b) => parseAgeRange(a.clasificacion) - parseAgeRange(b.clasificacion));
        const sortedMujeres = mujerData.sort((a, b) => parseAgeRange(a.clasificacion) - parseAgeRange(b.clasificacion));

        const chartData = {
            labels: sortedHombres.map(item => item.clasificacion),
            datasets: [
                {
                    label: 'Hombres',
                    backgroundColor: '#42A5F5',
                    data: sortedHombres.map(item => -parseFloat(item.resultado)),
                },
                {
                    label: 'Mujeres',
                    backgroundColor: '#EC407A',
                    data: sortedMujeres.map(item => parseFloat(item.resultado)),
                },
            ],
        };
        setFilteredData(chartData);
    };

    const prepareLineData = (data) => {
        const totalPoblacionData = data.filter(item => item.desagregaciontematica === 'Total población');
        const sortedData = totalPoblacionData.sort((a, b) => a.año - b.año);

        const chartData = {
            labels: sortedData.map(item => item.año),
            datasets: [
                {
                    label: 'Total Población',
                    borderColor: '#3e95cd',
                    fill: false,
                    data: sortedData.map(item => parseFloat(item.resultado)),
                },
            ],
        };

        setLineData(chartData);
    };
    const preparepieData = (data, year) => {
        // Filtrar los datos de "Porcentaje Hombres" y "Porcentaje Mujeres" para el año especificado
        const totalPoblacionDatah = data.find(item =>
            
            item.clasificacion === 'Porcentaje Hombres' &&
            item.año === year
        );
    
        const totalPoblacionDatam = data.find(item =>
            item.clasificacion === 'Porcentaje Mujeres' &&
            item.año === year
        );
    
        // Tomar los valores de porcentaje directamente
        const hombresResultado = totalPoblacionDatah ;
        const mujeresResultado = totalPoblacionDatam ;
    
        // Crear los datos para el gráfico de torta
        const pieData = {
            labels: ['Porcentaje Hombres', 'Porcentaje Mujeres'],
            datasets: [
                {
                    data: [hombresResultado * 100, mujeresResultado * 100], // Multiplicar por 100 para convertir a porcentaje
                    backgroundColor: ['#3e95cd', '#8e5ea2'], // Colores para Hombres y Mujeres
                },
            ],
        };
    
        setpieData(pieData); // Asigna los datos preparados al estado pieData
        console.log(pieData,'lkike')
    };
    
    
    const prepareAreaPieData = (data) => {
        // Filtrar los datos de "Porcentaje Urbano" y "Porcentaje Rural"
        const areaData = data.filter(item =>
            item.desagregaciontematica === 'Área' &&
            (item.clasificacion === 'Porcentaje Urbano' || item.clasificacion === 'Porcentaje Rural' && item.año === years)  // Filtrar por el año 2018
        );

        // Crear los datos para el gráfico de torta
        const pieData = {
            labels: ['Porcentaje Urbano', 'Porcentaje Rural'],
            datasets: [
                {
                    data: [
                        areaData.find(item => item.clasificacion === 'Porcentaje Urbano') ? parseFloat(areaData.find(item => item.clasificacion === 'Porcentaje Urbano').resultado) : 0,
                        areaData.find(item => item.clasificacion === 'Porcentaje Rural') ? parseFloat(areaData.find(item => item.clasificacion === 'Porcentaje Rural').resultado) : 0
                    ],
                    backgroundColor: ['#3e95cd', '#8e5ea2'], // Colores para Urbano y Rural
                },
            ],
        };

        setPieData(pieData);
    };
    const preparebarData = (data) => {
        // Filtrar los datos por "Grupo étnico" y excluir clasificaciones que contienen "porcentaje"
        const totalPoblacionData = data.filter(item =>
            item.desagregaciontematica === 'Grupo étnico' && !item.clasificacion.toLowerCase().includes('porcentaje')
        );

        // Agrupar los datos por clasificación
        const classificationGroups = totalPoblacionData.reduce((acc, item) => {
            if (!acc[item.clasificacion]) {
                acc[item.clasificacion] = [];
            }
            acc[item.clasificacion].push(item);
            return acc;
        }, {});

        // Crear los datos para la gráfica
        const chartData = {
            labels: Object.keys(classificationGroups), // Clasificación como etiquetas
            datasets: [
                {
                    label: 'Total Población',
                    backgroundColor: '#3e95cd', // Color de las barras
                    data: Object.values(classificationGroups).map(group => {
                        // Sumar los resultados de cada grupo de clasificación
                        return group.reduce((sum, item) => sum + parseFloat(item.resultado), 0);
                    }),
                },
            ],
        };

        setbineData(chartData);
    };

    const prepareBarData = (data, year) => {
        const totalPoblacionData = data.filter(item => item.desagregaciontematica === 'Total población' && item.año === year);

        const chartData = {
            labels: totalPoblacionData.map(item => item.municipio),
            datasets: [
                {
                    label: `Total Población en ${year}`,
                    backgroundColor: '#42A5F5',
                    data: totalPoblacionData.map(item => parseFloat(item.resultado)),
                },
            ],
        };

        setBarData(chartData);
    };

    useEffect(() => {
        if (rawData.length) {
            filterData(rawData, selectedYear, selectedAgeRange);
            prepareBarData(rawData, selectedYear); // Update bar data when year changes
        }
    }, [rawData, selectedYear, selectedAgeRange]);

    const handleYearChange = (value) => {
        setSelectedYear(value);
    };

    const handleAgeRangeChange = (value) => {
        setSelectedAgeRange(value);
    };

    return (
        <div>
            <h3>Total Poblacion</h3>
            <div className="filters">
                <Select defaultValue={selectedYear} onChange={handleYearChange} style={{ width: 120, marginRight: 10 }}>
                    {years.map(year => (
                        <Option key={year} value={year}>{year}</Option>
                    ))}
                </Select>
                <Select defaultValue="all" onChange={handleAgeRangeChange} style={{ width: 120 }}>
                    <Option value="all">All Ages</Option>
                    {rawData.length > 0 && [...new Set(rawData.map(item => item.clasificacion))]
                        .sort((a, b) => parseAgeRange(a) - parseAgeRange(b))
                        .map(ageRange => (
                            <Option key={ageRange} value={ageRange}>{ageRange}</Option>
                        ))}
                </Select>
            </div>
            <div >
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p>{error}</p>
                ) : (
                    <>
                        {filteredData ? (
                            <div>
                                <Bar
                                    data={filteredData}
                                    options={{
                                        indexAxis: 'y', // Cambiar para orientación horizontal
                                        scales: {
                                            x: {
                                                stacked: true,
                                                ticks: {
                                                    callback: value => Math.abs(value), // Mostrar solo los valores absolutos en los ticks
                                                },
                                            },
                                            y: {
                                                stacked: true,
                                            },
                                        },
                                        plugins: {
                                            tooltip: {
                                                callbacks: {
                                                    label: function (context) {
                                                        // Formatear la etiqueta del tooltip para mostrar solo valores absolutos
                                                        return `${context.dataset.label}: ${Math.abs(context.raw)}`;
                                                    },
                                                },
                                            },
                                        },
                                    }}
                                />
                            </div>
                        ) : (
                            <p>No data available</p>
                        )}

                        {lineData ? (
                            <div>
                                <Line
                                    data={lineData}
                                    options={{
                                        scales: {
                                            x: {
                                                title: {
                                                    display: true,
                                                    text: 'Año'
                                                }
                                            },
                                            y: {
                                                title: {
                                                    display: true,
                                                    text: 'Total Población'
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>
                        ) : (
                            <p>No line chart data available</p>
                        )}
                    </>
                )}
                {barData ? (
                    <div className="chart-container" style={{ position: 'relative', height: '500px', marginTop: '50px' }}>
                        <Bar
                            data={barData}
                            options={{

                                indexAxis: 'y', // Esto invierte las barras a orientación horizontal

                                scales: {
                                    x: {
                                        title: {
                                            display: true,
                                            text: 'Municipio'
                                        }
                                    },
                                    y: {
                                        title: {
                                            display: true,
                                            text: `Total Población en ${selectedYear}`
                                        }
                                    }
                                }
                            }}
                        />
                    </div>
                ) : (
                    <p>No bar chart data available</p>
                )}
                {barDataE ? (
                    <div className="chart-container" style={{ position: 'relative', height: '500px', marginTop: '50px' }}>
                        <Bar
                            data={barDataE}
                            options={{

                                indexAxis: 'y', // Esto invierte las barras a orientación horizontal

                                scales: {
                                    x: {
                                        title: {
                                            display: true,
                                            text: 'Municipio'
                                        }, min: 0, // Valor mínimo visible en el eje Y (puedes ajustarlo según tus necesidades)
                                        max: 1000000
                                    },
                                    y: {
                                        title: {
                                            display: true,
                                            text: `Total Población en ${selectedYear}`
                                        }
                                        ,
                                    }

                                }
                            }}
                        />
                    </div>
                ) : (
                    <p>No bar chart data available</p>
                )}
                {pieData ? (
                    <div className="chart" style={{ position: 'relative', height: '500px', marginTop: '50px' }}>
                        <Pie data={pieData} />
                    </div>
                ) : (
                    <p>No bar chart data available</p>
                )}

                {/* {pieData ? (
                    <div className="chart-container" style={{ position: 'relative', height: '500px', marginTop: '50px' }}>
                        <Pie data={pieData} />
                    </div>
                ) : (
                    <p>No pie chart data available</p>
                )} */}

            </div>
        </div >
    );
};

export default TotalPoblacion;
